module.exports = __webpack_public_path__ + "img/for-you06.e5b304d9.jpg";